@if (variant() === 'expanded') {
  @if (timeWindows()?.windows; as windows) {
    @for (window of windows; track window) {
      <div
        class="row f-body-xs {{ statusColor() }}"
        [class.f-muted]="!statusColor()"
      >
        <span>
          @if ($first) {
            {{
              `labels.${window.time ? 'fix' : 'timeWindowShort'}` | translate
            }}
          }
        </span>

        <ng-container
          *ngTemplateOutlet="windowTemplate; context: { window, status: true }"
        ></ng-container>
      </div>
    }
  } @else if (businessHours(); as businessHours) {
    @if (areBusinessHoursAlwaysOpen()) {
      <div
        class="row f-body-xs {{ statusColor() }}"
        [class.f-muted]="!statusColor()"
      >
        <span>
          {{ 'labels.opened' | translate }}
        </span>

        <span>24/7</span>
      </div>
    } @else {
      @for (key of businessHoursKeys(); track key) {
        <div
          class="row f-body-xs {{ statusColor() }}"
          [class.f-muted]="!statusColor()"
        >
          {{ businessHours | businessHours: key : 'short' : 'label' }}
          {{ businessHours | businessHours: key : 'short' : 'value' }}
        </div>
      }
    }
  }
} @else {
  @let isOrder = context() === 'order';
  @let windows = timeWindows()?.windows;

  @if (windows?.length) {
    @let window = windows[0];

    @if (isOrder) {
      <span class="label f-muted">
        {{ `labels.${window.time ? 'fix' : 'timeWindowShort'}` | translate }}
      </span>
    }

    <ng-container
      *ngTemplateOutlet="windowTemplate; context: { window }"
    ></ng-container>

    @if (windows.length > 1) {
      <span>, +{{ windows.length - 1 }}</span>
    }
  } @else if (businessHours(); as businessHours) {
    @if (areBusinessHoursAlwaysOpen()) {
      @if (isOrder) {
        <div class="label label-row">
          <p class="f-muted">{{ 'labels.opened' | translate }}</p>
          <p>24/7</p>
        </div>
      }
    } @else {
      @for (key of businessHoursKeys(); track key) {
        <span class="f-muted">
          {{ !$first ? ' · ' : '' }}
          {{ businessHours | businessHours: key : 'short' : 'label' }}
        </span>

        <span>
          {{ businessHours | businessHours: key : 'short' : 'value' }}
        </span>
      }
    }
  }
}

<ng-template let-window="window" let-status="status" #windowTemplate>
  @if (status) {
    <span>
      {{ window.time ?? window.timeRange | onyxTime: { showGap: false } }}
      ·
      {{ window.date! | onyxDate: 'date-dot' }}
    </span>
  } @else {
    <span class="f-body-s f-semibold">
      {{ window.time ?? window.timeRange | onyxTime: { showGap: false } }}
    </span>

    <span class="f-body-s f-medium">
      ·
      {{ window.date! | onyxDate: 'date-dot' }}
    </span>
  }
</ng-template>
